import type { AllRouteEndpoints } from "../routeTypes";
export const appsConnectedContentCredentialCreateCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/connected_content_credentials",
  "/app_settings/authentication_credentials",
];
